import { Crown } from "lucide-react";
import { useTopConnector } from "@/lib/useTopConnector";
import { cn } from "@/lib/utils";

// Amber "Top Connector" crown for the month's #1 inviter. Renders nothing unless the given user
// matches the current leaderboard leader (or `me` and the viewer is #1). `iconOnly` for tight rows.
export function TopConnectorCrown({ match, me = false, iconOnly = false, className = "" }) {
  const { meIsTop, isTopConnector } = useTopConnector();
  const show = (me && meIsTop) || isTopConnector(match);
  if (!show) return null;

  if (iconOnly) {
    return (
      <span
        className={cn("inline-flex items-center justify-center text-amber-300", className)}
        data-testid="top-connector-crown"
        title="Top Connector — #1 inviter this month"
      >
        <Crown className="h-3.5 w-3.5" fill="currentColor" />
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-amber-400/40 bg-amber-400/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-300",
        className,
      )}
      data-testid="top-connector-crown"
      title="Top Connector — #1 inviter this month"
    >
      <Crown className="h-3 w-3" /> Top Connector
    </span>
  );
}
